import { render, staticRenderFns } from "./scroll_item.vue?vue&type=template&id=78e00e58&scoped=true&"
var script = {}
import style0 from "./scroll_item.vue?vue&type=style&index=0&id=78e00e58&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e00e58",
  null
  
)

export default component.exports